import FromPageIndicator from "../Common/FromPageIndicator";
import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  Form,
  Button,
  Row,
  Col,
  Alert,
  Tabs,
  Tab,
  Table,
  Badge,
  Modal,
} from "react-bootstrap";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import SampleAbstractPDF from "../../Assets/AbstractTemplatetnpyAmpicon2025.docx";
import CustomAlert from "../CustomAlert/CustomAlert";

const AbstractSubmission = () => {
  const [paymentStatus, setPaymentStatus] = useState("PENDING");
  const [payLater, setPayLater] = useState("NO");
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [activeTab, setActiveTab] = useState("new");
  const [abstractCount, setAbstractCount] = useState(0);
  const [abstractEndDate] = useState(new Date("2025-09-01"));
  const [isEndDatePassed, setIsEndDatePassed] = useState(false);
  const [previousAbstracts, setPreviousAbstracts] = useState([]);
  const [viewingAbstract, setViewingAbstract] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [wordCount, setWordCount] = useState(0);
  const registrationCategory =
    sessionStorage.getItem("registrationCategory") || "Others";
  console.log("Registration Category:", registrationCategory);
  // New state for custom alerts
  const [alerts, setAlerts] = useState({
    paymentStatus: false,
    submission: false,
    error: false,
    endDateWarning: false,
    noAbstracts: false,
  });

  const [formData, setFormData] = useState({
    presentationType1: "",
    title: "",
    category: "",
    presentationType: "",
    correspondingAuthor: {
      name: "",
      email: "",
      mobile: "",
      institution: "",
    },
    authors: [
      {
        name: "",
        department: "",
        institution: "",
        city: "",
        isCorresponding: true,
      },
    ],
    abstract: {
      background: "",
      methods: "",
      results: "",
      conclusion: "",
    },
    keywords: "",
    file: null,
    submissionDate: null,
    lastEditDate: null,
  });

  useEffect(() => {
    const checkAndFetch = async () => {
      const emailId =
        localStorage.getItem("emailId") || sessionStorage.getItem("emailId");

      if (!emailId) {
        alert("Login to continue");
        navigate("/login-page");
        return;
      }

      await fetchUserData();
      setIsEndDatePassed(new Date() > abstractEndDate);
      fetchPreviousAbstracts(emailId);
    };

    checkAndFetch();
    // eslint-disable-next-line
  }, []);

  // Calculate word count whenever abstract content changes
  useEffect(() => {
    const calculateWordCount = () => {
      const { background, methods, results, conclusion } = formData.abstract;
      const fullText = `${background} ${methods} ${results} ${conclusion}`;
      const words = fullText.trim().split(/\s+/);
      return words.filter((word) => word.length > 0).length;
    };

    setWordCount(calculateWordCount());
  }, [formData.abstract]);

  const showAlert = (type) => {
    setAlerts((prev) => ({ ...prev, [type]: true }));
  };

  const hideAlert = (type) => {
    setAlerts((prev) => ({ ...prev, [type]: false }));
  };

  const fetchUserData = async () => {
    const RegUserID =
      sessionStorage.getItem("userId") || localStorage.getItem("userId");
    try {
      const response = await fetch(
        `https://api.dremerz.net/api/DZ_8921_Ampicon_Create_Users_UserList/${RegUserID}`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Some Error Occured");
      }
      const data = await response.json();

      // Update payment status and show alert
      setPaymentStatus(data.paymentStatus || "PENDING");
      setPayLater(data.payLater || "NO");

      if (data.paymentStatus !== "PAID") {
        showAlert("paymentStatus");
      }

      return data;
    } catch (error) {
      console.log(error.message);
      return null;
    }
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = SampleAbstractPDF;
    link.download = "Abstract Template tnpy ampicon2025";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fetchPreviousAbstracts = async (email) => {
    try {
      const absResponse = await fetch(
        `https://api.dremerz.net/api/DZ_8921_Ampicon_Create_Records_AbstractRecords?email=${email}`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
          },
        }
      );
      if (!absResponse.ok) {
        throw new Error("Some error occured");
      }
      const previousAbstracts = await absResponse.json();
      console.log(previousAbstracts);

      const parsedAbstracts = previousAbstracts.map((abstract) => ({
        ...abstract,
        correspondingAuthor: JSON.parse(abstract.correspondingAuthor),
        authors: JSON.parse(abstract.authors),
        abstract: JSON.parse(abstract.abstract),
      }));

      setPreviousAbstracts(parsedAbstracts);
      setAbstractCount(previousAbstracts.length);

      if (previousAbstracts.length === 0) {
        showAlert("noAbstracts");
      }
    } catch (error) {
      console.log(error.message);
      setErrorMessage("Failed to fetch previous abstracts");
      showAlert("error");
    }
  };

  const categories = [
    "Radiation Oncology: Physics and Dosimetry",
    "Diagnostic Imaging: Physics and Dosimetry",
    "Nuclear Medicine: Physics and Dosimetry",
    "Image Processing, Analysis and Quantification",
    "Particle Therapy and Dosimetry",
    "Monte-Carlo Modelling and Simulation",
    "AI/ML in Medical Physics & Clinical Implementation",
    "IGRT and Adaptive Radiotherapy",
    "Radiation Biology, Protection, and Safety",
    "Diagnostic & Therapeutic Instrumentation",
    "3D Printing, QA Device, Phantom Design",
    "Medical Physics Education and Certification",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.includes(".")) {
      const [parent, child] = name.split(".");
      setFormData({
        ...formData,
        [parent]: {
          ...formData[parent],
          [child]: value,
        },
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleNewAbstract = () => {
    if (wordCount > 350) {
      setErrorMessage("Abstract exceeds 350 word limit");
      showAlert("error");
      return;
    }

    const abstractData = {
      email: localStorage.getItem("emailId"),
      userId: parseInt(localStorage.getItem("userId")),
      title: formData.title,
      category: formData.category,
      presentationType: formData.presentationType,
      presentationType1: formData.presentationType1,
      correspondingAuthor: {
        name: formData.correspondingAuthor.name,
        email: formData.correspondingAuthor.email,
        mobile: formData.correspondingAuthor.mobile,
        institution: formData.correspondingAuthor.institution,
      },
      authors: formData.authors,
      abstract: {
        background: formData.abstract.background,
        methods: formData.abstract.methods,
        results: formData.abstract.results,
        conclusion: formData.abstract.conclusion,
      },
      keywords: formData.keywords,
      submissionDate: new Date().toISOString(),
      lastEditDate: new Date().toISOString(),
      status: "pending",
      payLater: payLater,
      paymentStatus: paymentStatus,
      registrationCategory: registrationCategory,
    };

    fetch(
      "https://api.dremerz.net/api/DZ_8921_Ampicon_Create_Records_AbstractRecords/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(abstractData),
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Success:", data);
        setSubmitted(true);
        showAlert("submission");

        const newAbstract = {
          ...abstractData,
        };

        setPreviousAbstracts([...previousAbstracts, newAbstract]);
        setAbstractCount(abstractCount + 1);

        setTimeout(() => {
          resetForm();
          setActiveTab("previous");
          hideAlert("submission");
        }, 3000);
      })
      .catch((error) => {
        console.error("Error:", error);
        setErrorMessage(
          "There was a problem submitting your abstract. Please try again."
        );
        showAlert("error");
      });
  };

  const handleUpdateAbstract = () => {
    if (wordCount > 350) {
      setErrorMessage("Abstract exceeds 350 word limit");
      showAlert("error");
      return;
    }

    const abstractData = {
      email: localStorage.getItem("emailId"),
      userId: parseInt(localStorage.getItem("userId")),
      title: formData.title,
      category: formData.category,
      presentationType: formData.presentationType,
      presentationType1: formData.presentationType1,
      correspondingAuthor: {
        name: formData.correspondingAuthor.name,
        email: formData.correspondingAuthor.email,
        mobile: formData.correspondingAuthor.mobile,
        institution: formData.correspondingAuthor.institution,
      },
      authors: formData.authors,
      abstract: {
        background: formData.abstract.background,
        methods: formData.abstract.methods,
        results: formData.abstract.results,
        conclusion: formData.abstract.conclusion,
      },
      keywords: formData.keywords,
      submissionDate: formData.submissionDate,
      lastEditDate: new Date().toISOString(),
      payLater: payLater,
      paymentStatus: paymentStatus,
      registrationCategory: registrationCategory,
    };

    fetch(
      `https://api.dremerz.net/api/DZ_8921_Ampicon_Create_Records_AbstractRecords/${formData.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(abstractData),
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Update Success:", data);
        setSubmitted(true);
        alert("Abstract Updated Successfully");

        const updatedAbstracts = previousAbstracts.map((abstract) =>
          abstract.id === formData.id ? abstractData : abstract
        );

        setPreviousAbstracts(updatedAbstracts);

        setTimeout(() => {
          resetForm();
          setActiveTab("previous");
        }, 3000);
      })
      .catch((error) => {
        console.error("Error:", error);
        setErrorMessage(
          "There was a problem updating your abstract. Please try again."
        );
      });
  };

  const handleAuthorChange = (index, field, value) => {
    const updatedAuthors = [...formData.authors];
    updatedAuthors[index] = {
      ...updatedAuthors[index],
      [field]: value,
    };

    setFormData({
      ...formData,
      authors: updatedAuthors,
    });
  };

  const handleCorrespondingAuthorChange = (index) => {
    const updatedAuthors = formData.authors.map((author, i) => ({
      ...author,
      isCorresponding: i === index,
    }));

    const correspondingAuthor = {
      name: updatedAuthors[index].name,
      email: formData.correspondingAuthor.email,
      mobile: formData.correspondingAuthor.mobile,
      institution: updatedAuthors[index].institution,
    };

    setFormData({
      ...formData,
      authors: updatedAuthors,
      correspondingAuthor: correspondingAuthor,
    });
  };

  const addAuthor = () => {
    if (formData.authors.length >= 5) {
      setErrorMessage("Maximum 5 authors allowed");
      return;
    }

    setFormData({
      ...formData,
      authors: [
        ...formData.authors,
        {
          name: "",
          department: "",
          institution: "",
          city: "",
          isCorresponding: false,
        },
      ],
    });
    setErrorMessage("");
  };

  const removeAuthor = (index) => {
    if (formData.authors.length <= 1) {
      setErrorMessage("At least one author is required");
      return;
    }

    // If removing the corresponding author, set first author as corresponding
    let updatedAuthors = [...formData.authors];
    const isRemovingCorresponding = updatedAuthors[index].isCorresponding;

    updatedAuthors = updatedAuthors.filter((_, i) => i !== index);

    if (isRemovingCorresponding && updatedAuthors.length > 0) {
      updatedAuthors[0].isCorresponding = true;

      // Update corresponding author details
      const correspondingAuthor = {
        name: updatedAuthors[0].name,
        email: formData.correspondingAuthor.email,
        mobile: formData.correspondingAuthor.mobile,
        institution: updatedAuthors[0].institution,
      };

      setFormData({
        ...formData,
        authors: updatedAuthors,
        correspondingAuthor: correspondingAuthor,
      });
    } else {
      setFormData({
        ...formData,
        authors: updatedAuthors,
      });
    }
    setErrorMessage("");
  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    if (abstractCount >= 2 && !editMode) {
      setErrorMessage("max 2 submissions allowed");
      showAlert("error");
      return;
    }

    if (wordCount > 350) {
      setErrorMessage("Abstract exceeds 350 word limit");
      showAlert("error");
      return;
    }

    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    if (editMode) {
      handleUpdateAbstract();
    } else {
      handleNewAbstract();
    }
  };

  const resetForm = () => {
    setFormData({
      id: "",
      title: "",
      category: "",
      presentationType: "",
      presentationType1: "",
      correspondingAuthor: {
        name: "",
        email: "",
        mobile: "",
        institution: "",
      },
      authors: [
        {
          name: "",
          department: "",
          institution: "",
          city: "",
          isCorresponding: true,
        },
      ],
      abstract: {
        background: "",
        methods: "",
        results: "",
        conclusion: "",
      },
      keywords: "",
      submissionDate: null,
      lastEditDate: null,
    });
    setValidated(false);
    setSubmitted(false);
    setEditMode(false);
    setErrorMessage("");
    setWordCount(0);
  };

  const handleEdit = (abstract) => {
    if (isEndDatePassed) {
      setErrorMessage("Editing is not allowed after the submission deadline");
      return;
    }

    setFormData(abstract);
    setEditMode(true);
    setActiveTab("new");
  };

  const handleView = (abstract) => {
    setViewingAbstract(abstract);
  };

  const renderPreview = () => {
    const abstract = viewingAbstract;
    // if (!abstract.title) return null;

    const correspondingAuthor =
      abstract.authors.find((a) => a.isCorresponding) || abstract.authors[0];
    const correspondingEmail =
      abstract.correspondingAuthor.email || "not provided";

    return (
      <div className="preview-container p-4 border rounded bg-white">
        <h5 className="mb-4">Abstract Preview </h5>

        <div className="preview-content">
          {/* Title */}
          <div
            style={{
              fontFamily: "Arial",
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "8px",
            }}
          >
            {abstract.title}
          </div>

          {/* Authors */}
          <div
            style={{
              fontFamily: "Arial",
              fontStyle: "italic",
              fontSize: "14px",
              marginBottom: "16px",
            }}
          >
            {abstract.authors.map((author, i) => (
              <div key={i}>
                {author.name}, {author.department}, {author.institution},{" "}
                {author.city}
                {author.isCorresponding && `. Email: ${correspondingEmail}`}
              </div>
            ))}
          </div>

          {/* Background */}
          <div style={{ marginBottom: "12px" }}>
            <div
              style={{
                fontFamily: "Arial",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              Background and Aim
            </div>
            <div style={{ fontFamily: "Arial", fontSize: "14px" }}>
              {abstract.abstract.background}
            </div>
          </div>

          {/* Methods */}
          <div style={{ marginBottom: "12px" }}>
            <div
              style={{
                fontFamily: "Arial",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              Materials & Methods
            </div>
            <div style={{ fontFamily: "Arial", fontSize: "14px" }}>
              {abstract.abstract.methods}
            </div>
          </div>

          {/* Results */}
          <div style={{ marginBottom: "12px" }}>
            <div
              style={{
                fontFamily: "Arial",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              Results and Discussion
            </div>
            <div style={{ fontFamily: "Arial", fontSize: "14px" }}>
              {abstract.abstract.results}
            </div>
          </div>

          {/* Conclusion */}
          <div style={{ marginBottom: "12px" }}>
            <div
              style={{
                fontFamily: "Arial",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              Conclusion
            </div>
            <div style={{ fontFamily: "Arial", fontSize: "14px" }}>
              {abstract.abstract.conclusion}
            </div>
          </div>

          {/* Keywords */}
          <div>
            <div
              style={{
                fontFamily: "Arial",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              Keywords:
            </div>
            <div style={{ fontFamily: "Arial", fontSize: "14px" }}>
              {abstract.keywords}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Fixed Position Alert Container */}
      <div
        style={{
          position: "fixed",
          top: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 9999,
          width: "90%",
          maxWidth: "600px",
          pointerEvents: "none",
        }}
      >
        {/* Custom Payment Status Alert */}
        <div style={{ pointerEvents: "auto", marginBottom: "10px" }}>
          <CustomAlert
            show={alerts.paymentStatus}
            onClose={() => hideAlert("paymentStatus")}
            variant={payLater === "YES" ? "info" : "warning"}
            title={
              payLater === "YES"
                ? "Pay Later Option Selected"
                : "Payment Pending"
            }
            message={
              payLater === "YES"
                ? "You've chosen to pay later. Please complete your payment before the conference."
                : "Your payment is still pending."
            }
            actionButton={
              <Button
                variant="primary"
                size="sm"
                onClick={() => navigate("/paymentPage")}
                style={{
                  backgroundColor: "#2482a1",
                  borderColor: "#2482a1",
                }}
              >
                {payLater === "YES"
                  ? "Complete Payment Now"
                  : "Proceed to Payment"}
              </Button>
            }
            icon={payLater === "YES" ? "💳" : "⚠️"}
            size="normal"
          />
        </div>

        {/* Custom Submission Success Alert */}
        <div style={{ pointerEvents: "auto", marginBottom: "10px" }}>
          <CustomAlert
            show={alerts.submission}
            onClose={() => hideAlert("submission")}
            variant="success"
            title={
              editMode
                ? "Abstract Updated Successfully!"
                : "Thank you for your submission!"
            }
            message={`Your abstract has been ${
              editMode ? "updated" : "submitted"
            } successfully.${
              paymentStatus !== "PAID"
                ? " Please complete your payment before the conference."
                : ""
            }`}
            icon="🎉"
            autoClose={true}
            autoCloseDelay={4000}
            size="normal"
          />
        </div>

        {/* Custom Error Alert */}
        <div style={{ pointerEvents: "auto", marginBottom: "10px" }}>
          <CustomAlert
            show={alerts.error}
            onClose={() => hideAlert("error")}
            variant="danger"
            title="Error"
            message={errorMessage}
            icon="⚠️"
            size="normal"
          />
        </div>

        {/* Custom End Date Warning Alert */}
        <div style={{ pointerEvents: "auto", marginBottom: "10px" }}>
          <CustomAlert
            show={alerts.endDateWarning && isEndDatePassed}
            onClose={() => hideAlert("endDateWarning")}
            variant="warning"
            title="Submission Deadline Passed"
            message={`Abstract submission is closed. The deadline was ${format(
              abstractEndDate,
              "MMMM d, yyyy"
            )}.`}
            icon="⏰"
            size="normal"
          />
        </div>

        {/* Custom No Abstracts Alert */}
        <div style={{ pointerEvents: "auto", marginBottom: "10px" }}>
          <CustomAlert
            show={alerts.noAbstracts}
            onClose={() => hideAlert("noAbstracts")}
            variant="info"
            title="No Submissions Yet"
            message="You haven't submitted any abstracts yet. Click on 'New Abstract' tab to submit your first abstract."
            icon="📝"
            actionButton={
              <Button
                variant="primary"
                size="sm"
                onClick={() => {
                  setActiveTab("new");
                  hideAlert("noAbstracts");
                }}
                style={{
                  backgroundColor: "#2482a1",
                  borderColor: "#2482a1",
                }}
              >
                Submit New Abstract
              </Button>
            }
            size="normal"
          />
        </div>
      </div>

      <FromPageIndicator />
      <Container
        fluid
        className="py-5 px-4"
        style={{ backgroundColor: "#FFF4FA" }}
      >
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <div
            className="mx-auto"
            style={{ width: "100%", maxWidth: "1000px" }}
          >
            <Card className="shadow-lg border-0 rounded-4 w-100">
              <Card.Body className="p-5">
                <h2
                  className="text-center fw-bold mb-4"
                  style={{ color: "#2482a1" }}
                >
                  TNPY AMPICON 2025 - Abstract Submission
                </h2>

                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h6>
                      Abstract Status:
                      <Badge
                        bg={isEndDatePassed ? "danger" : "success"}
                        className="ms-2"
                      >
                        {isEndDatePassed ? "Closed" : "Open"}
                      </Badge>
                    </h6>
                    <small className="text-muted">
                      Submission Deadline:{" "}
                      {/* {format(abstractEndDate, "MMMM d, yyyy")} */}
                      August 20, 2025
                    </small>
                    <br></br>
                    <small className="text-muted">
                      {/* Extendable: August 31,2025{" "} */}
                      Extendable: ***Expired{" "}
                    </small>
                  </div>
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <Button
                      variant="info"
                      className="text-white mb-2"
                      onClick={handleDownload}
                    >
                      Download sample
                    </Button>
                    <Badge bg="primary" className="me-2">
                      Submitted Abstracts: {abstractCount}/2
                    </Badge>
                  </div>
                </div>

                <Tabs
                  activeKey={activeTab}
                  onSelect={(k) => {
                    setActiveTab(k);
                    if (k === "new" && !editMode) {
                      resetForm();
                    }
                  }}
                  className="mb-4"
                >
                  <Tab
                    eventKey="new"
                    title={editMode ? "Edit Abstract" : "New Abstract"}
                  >
                    {isEndDatePassed && !editMode ? (
                      ""
                    ) : (
                      <Form
                        noValidate
                        validated={validated}
                        onSubmit={handleSubmit}
                      >
                        <Form.Group className="mb-4">
                          <Form.Label>
                            <strong>Abstract Title</strong>
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            required
                            placeholder="Enter your abstract title"
                            disabled={isEndDatePassed && !editMode}
                          />
                          <Form.Text className="text-muted">
                            Must be clear, descriptive, and without
                            abbreviations.
                          </Form.Text>
                          <Form.Control.Feedback type="invalid">
                            Please provide a title for your abstract.
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Row className="mb-4">
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>
                                <strong>Abstract Category</strong>{" "}
                                <span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Select
                                name="category"
                                value={formData.category}
                                onChange={handleChange}
                                required
                                disabled={isEndDatePassed && !editMode}
                              >
                                <option value="">Select a category</option>
                                {categories.map((category, index) => (
                                  <option key={index} value={category}>
                                    {category}
                                  </option>
                                ))}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please select a category.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group controlId="presentationType1">
                              <Form.Label>
                                <strong>Presentation Type</strong>{" "}
                                <span className="text-danger">*</span>
                              </Form.Label>

                              <Form.Select
                                name="presentationType1"
                                value={formData.presentationType1}
                                onChange={handleChange}
                                required
                                disabled={isEndDatePassed && !editMode}
                              >
                                <option value="">Select a category</option>
                                <option value="Oral">Oral</option>
                                <option value="E-Poster">E-Poster</option>
                              </Form.Select>

                              <Form.Control.Feedback type="invalid">
                                Please select a Presentation Type.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>

                        <h4 className="mt-5 mb-3" style={{ color: "#2482a1" }}>
                          Authors Information
                        </h4>

                        <div className="authors-container">
                          {formData.authors.map((author, index) => (
                            <div
                              key={index}
                              className="author-entry mb-4 p-3 border rounded"
                            >
                              <div className="d-flex justify-content-between mb-2">
                                <h5>Author {index + 1}</h5>
                                <div>
                                  <Form.Check
                                    type="radio"
                                    id={`corresponding-${index}`}
                                    label="First Author"
                                    checked={author.isCorresponding}
                                    onChange={() =>
                                      handleCorrespondingAuthorChange(index)
                                    }
                                    inline
                                    disabled={isEndDatePassed && !editMode}
                                  />
                                  {index > 0 && (
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      onClick={() => removeAuthor(index)}
                                      disabled={isEndDatePassed && !editMode}
                                    >
                                      Remove
                                    </Button>
                                  )}
                                </div>
                              </div>

                              <Row>
                                <Col md={6}>
                                  <Form.Group className="mb-3">
                                    <Form.Label>
                                      Full Name{" "}
                                      <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={author.name}
                                      onChange={(e) =>
                                        handleAuthorChange(
                                          index,
                                          "name",
                                          e.target.value
                                        )
                                      }
                                      required
                                      placeholder="Enter full name"
                                      disabled={isEndDatePassed && !editMode}
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group className="mb-3">
                                    <Form.Label>
                                      Department/Role{" "}
                                      <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={author.department}
                                      onChange={(e) =>
                                        handleAuthorChange(
                                          index,
                                          "department",
                                          e.target.value
                                        )
                                      }
                                      required
                                      placeholder="Enter department/role"
                                      disabled={isEndDatePassed && !editMode}
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={6}>
                                  <Form.Group className="mb-3">
                                    <Form.Label>
                                      Institution{" "}
                                      <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={author.institution}
                                      onChange={(e) =>
                                        handleAuthorChange(
                                          index,
                                          "institution",
                                          e.target.value
                                        )
                                      }
                                      required
                                      placeholder="Enter institution name"
                                      disabled={isEndDatePassed && !editMode}
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group className="mb-3">
                                    <Form.Label>
                                      City{" "}
                                      <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={author.city}
                                      onChange={(e) =>
                                        handleAuthorChange(
                                          index,
                                          "city",
                                          e.target.value
                                        )
                                      }
                                      required
                                      placeholder="Enter city"
                                      disabled={isEndDatePassed && !editMode}
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>

                              {author.isCorresponding && (
                                <Row>
                                  <Col md={6}>
                                    <Form.Group className="mb-3">
                                      <Form.Label>
                                        Email Address{" "}
                                        <span className="text-danger">*</span>
                                      </Form.Label>
                                      <Form.Control
                                        type="email"
                                        name="correspondingAuthor.email"
                                        value={
                                          formData.correspondingAuthor.email
                                        }
                                        onChange={handleChange}
                                        required
                                        placeholder="Enter email address"
                                        disabled={isEndDatePassed && !editMode}
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md={6}>
                                    <Form.Group className="mb-3">
                                      <Form.Label>
                                        Mobile Number{" "}
                                        <span className="text-danger">*</span>
                                      </Form.Label>
                                      <Form.Control
                                        type="tel"
                                        name="correspondingAuthor.mobile"
                                        value={
                                          formData.correspondingAuthor.mobile
                                        }
                                        onChange={handleChange}
                                        required
                                        placeholder="Enter mobile number"
                                        disabled={isEndDatePassed && !editMode}
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                              )}
                            </div>
                          ))}

                          <div className="d-flex justify-content-end mb-4">
                            <Button
                              variant="outline-primary"
                              onClick={addAuthor}
                              disabled={
                                formData.authors.length >= 5 ||
                                (isEndDatePassed && !editMode)
                              }
                            >
                              Add Author (Max 5)
                            </Button>
                          </div>
                        </div>

                        <h4
                          className="mt-5 mb-3  "
                          style={{ color: "#2482a1" }}
                        >
                          Abstract Content
                          <span
                            style={{
                              fontSize: "0.9rem",
                              color: wordCount > 350 ? "#dc3545" : "#6c757d",
                            }}
                            className="ms-2"
                          >
                            {`( Word Count: ${wordCount}/350 )`}
                          </span>
                        </h4>

                        {wordCount > 350 && (
                          <Alert variant="danger">
                            Word Count: {wordCount}/350 words
                            <span className="ms-2">
                              (Exceeds limit by {wordCount - 350} words)
                            </span>
                          </Alert>
                        )}

                        <Form.Group className="mb-3">
                          <Form.Label>
                            <strong>Background and Aim</strong>
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="abstract.background"
                            value={formData.abstract.background}
                            onChange={handleChange}
                            required
                            placeholder="Enter background and aim of your research"
                            disabled={isEndDatePassed && !editMode}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>
                            <strong>Materials and Methods</strong>
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="abstract.methods"
                            value={formData.abstract.methods}
                            onChange={handleChange}
                            required
                            placeholder="Enter materials and methods used"
                            disabled={isEndDatePassed && !editMode}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>
                            <strong>Results and Discussion</strong>
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="abstract.results"
                            value={formData.abstract.results}
                            onChange={handleChange}
                            required
                            placeholder="Enter results and discussion"
                            disabled={isEndDatePassed && !editMode}
                          />
                        </Form.Group>

                        <Form.Group className="mb-4">
                          <Form.Label>
                            <strong>Conclusion</strong>
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="abstract.conclusion"
                            value={formData.abstract.conclusion}
                            onChange={handleChange}
                            required
                            placeholder="Enter conclusion"
                            disabled={isEndDatePassed && !editMode}
                          />
                        </Form.Group>

                        <Form.Group className="mb-4">
                          <Form.Label>
                            <strong>Keywords</strong> (separated by commas
                            (e.g., Medical Physics, Artificial Intelligence ,
                            Adaptive Radiation Therapy))
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="keywords"
                            value={formData.keywords}
                            onChange={handleChange}
                            required
                            placeholder="Enter keywords"
                            disabled={isEndDatePassed && !editMode}
                          />
                          <Form.Text className="text-muted">
                            Provide three relevant keywords reflecting the
                            research content.
                          </Form.Text>
                          <Form.Control.Feedback type="invalid">
                            Please provide at least three keywords.
                          </Form.Control.Feedback>
                        </Form.Group>

                        <div className="d-flex gap-2">
                          <Button
                            variant="info"
                            size="md"
                            style={{
                              backgroundColor: "#2482a1",
                              borderColor: "#2482a1",
                            }}
                            disabled={isEndDatePassed && !editMode}
                            onClick={() => {
                              handleView(formData);
                            }}
                            className="text-white"
                          >
                            Preview
                          </Button>
                          <Button
                            variant="primary"
                            size="md"
                            type="submit"
                            style={{
                              backgroundColor: "#2482a1",
                              borderColor: "#2482a1",
                            }}
                            disabled={isEndDatePassed && !editMode}
                          >
                            {editMode ? "Update Abstract" : "Submit Abstract"}
                          </Button>
                        </div>

                        <div className="text-center mt-3">
                          <small className="text-muted">
                            By submitting this form, you confirm that all
                            information is accurate and that you have adhered to
                            the abstract submission guidelines.
                          </small>
                        </div>
                      </Form>
                    )}
                  </Tab>

                  <Tab eventKey="previous" title="Previous Submissions">
                    {previousAbstracts.length === 0 ? (
                      <Alert variant="info">
                        You haven't submitted any abstracts yet.
                      </Alert>
                    ) : (
                      <>
                        <Table responsive hover className="align-middle">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Title</th>
                              <th>Category</th>
                              <th>Type</th>
                              <th>Status</th>
                              <th>Submission Date</th>
                              <th>Last Edited</th>
                              <th>Actions</th>
                              <th>Payment Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {previousAbstracts.map((abstract, index) => (
                              <tr key={abstract.id}>
                                <td>{index + 1}</td>
                                <td>{abstract.title}</td>
                                <td>{abstract.category}</td>
                                <td>{abstract.presentationType1}</td>
                                <td>
                                  {abstract.status
                                    ? abstract.status
                                    : "Waiting"}
                                  {abstract.abstractReferenceId !== "" && (
                                    <Badge bg="info" className="">
                                      {abstract.abstractReferenceId}
                                    </Badge>
                                  )}
                                  {abstract.abstractReferenceId !== "" && (
                                    <Badge bg="warning">
                                      {abstract.presentationScore}
                                    </Badge>
                                  )}
                                </td>
                                <td>
                                  {format(
                                    new Date(abstract.submissionDate),
                                    "MMM d, yyyy"
                                  )}
                                </td>
                                <td>
                                  {format(
                                    new Date(abstract.lastEditDate),
                                    "MMM d, yyyy"
                                  )}
                                </td>
                                <td>
                                  <Button
                                    variant="outline-primary"
                                    size="sm"
                                    className="me-2 mb-1"
                                    onClick={() => handleView(abstract)}
                                    style={{ width: "50px" }}
                                  >
                                    View
                                  </Button>
                                  {!isEndDatePassed && (
                                    <Button
                                      variant="outline-secondary"
                                      size="sm"
                                      onClick={() => handleEdit(abstract)}
                                      style={{ width: "50px" }}
                                      disabled={abstract.status === "accepted"}
                                    >
                                      Edit
                                    </Button>
                                  )}
                                </td>
                                <td>
                                  <Badge
                                    bg={
                                      paymentStatus === "PAID"
                                        ? "success"
                                        : payLater === "YES"
                                        ? "info"
                                        : "info"
                                    }
                                    className="ms-2"
                                    style={{
                                      cursor:
                                        paymentStatus === "PAID"
                                          ? "default"
                                          : "pointer",
                                    }}
                                    onClick={
                                      paymentStatus === "PAID"
                                        ? undefined
                                        : () => navigate("/paymentPage")
                                    }
                                  >
                                    {paymentStatus === "PAID"
                                      ? "PAID"
                                      : payLater === "YES"
                                      ? "PAY LATER"
                                      : "PAY LATER"}
                                  </Badge>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>

                        {viewingAbstract && (
                          <Modal
                            show={true}
                            onHide={() => setViewingAbstract(null)}
                            size="lg"
                            centered
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Abstract Preview</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>{renderPreview()}</Modal.Body>

                            <Modal.Footer>
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => setViewingAbstract(null)}
                              >
                                Close Preview
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        )}
                      </>
                    )}

                    {!isEndDatePassed && abstractCount < 2 && (
                      <div className="d-flex justify-content-center mt-4">
                        <Button
                          variant="primary"
                          onClick={() => {
                            resetForm();
                            setActiveTab("new");
                          }}
                          style={{
                            backgroundColor: "#2482a1",
                            borderColor: "#2482a1",
                          }}
                        >
                          Submit Another Abstract
                        </Button>
                      </div>
                    )}
                  </Tab>
                </Tabs>
              </Card.Body>
            </Card>
          </div>
        </motion.div>
      </Container>
    </>
  );
};

export default AbstractSubmission;
